// @file Javascript for Profile page. Simple run-time Vue app.
import { hyphenatedCurrentLocale } from 'bits/current_locale'
import user from 'bits/current_user'
import environment from 'bits/environment'
import * as errorTracker from 'bits/error_tracker'
import 'styles/tailwind.css'
import { configureApiFetch } from 'surface/api_fetch'
import Vue, { CreateElement, VNode } from 'vue'
import IntlPlugin from 'vueplugins/intl_plugin'
import VueApollo from 'vue-apollo'
import UserProfilePage from 'vuecomponents/user_profile_page.vue'
import store from 'vuexstore/profile'

configureApiFetch({ useArvo: false })

errorTracker.init({
  vue: Vue,
  userId: user.id,
  environment: environment,
  locale: hyphenatedCurrentLocale,
  release: document?.documentElement?.dataset?.version,
})

Vue.use(VueApollo)
Vue.use(IntlPlugin)

store.dispatch('initializeState')

const DOMContentLoadedPromise = new Promise((resolve) => {
  document.addEventListener('DOMContentLoaded', (): void => {
    resolve()
  })
})

// These initializations depend on DOMContentLoaded only.
DOMContentLoadedPromise.then(() => {
  new Vue({
    el: '#app',
    store,
    render: (h: CreateElement): VNode => h(UserProfilePage),
  })
})
